'use strict';

var matchJS = {
  exec: function (APP, controller, action) {
    var namespace = APP;
    action = (action === undefined) ? "init" : action;

    if (controller !== "" && namespace[controller] && typeof namespace[controller][action] == "function") {
        namespace[controller][action]();
    }
  },

  init: function (APP) {
    var body = document.body;
    var controller = body.getAttribute("data-controller");
    var action = body.getAttribute("data-action");

    matchJS.exec(APP, "common");
    matchJS.exec(APP, controller);
    matchJS.exec(APP, controller, "common");
    matchJS.exec(APP, controller, action);
  }
};

export default matchJS;
